import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Stack,
  Box,
  Divider,
  Typography,
  TextField,
  Button,
} from '@mui/material';
import Iconify from '@/components/Iconify';
import useMobile from '@/hooks/useMobile';
import { isEqualString } from '@/utils/validations';

export default function FanPass({ onChange, fanPass }) {
  const { t } = useTranslation();
  const { isMobile } = useMobile();
  const [value, setValue] = useState('');
  const [error, setError] = useState();
  const onChangeHandler = (ev) => {
    setValue(ev.target.value);
  };
  const onContinue = () => {
    if (isEqualString(value, fanPass)) {
      onChange(value);
    } else {
      setError('Contraseña incorrecta');
    }
  };
  return (
    <Box
      sx={{
        width: '100%',
        minHeight: '100px',
        borderRadius: '16px',
        border: 'solid 1px #E0E0FF',
        background: '#FEFEFF',
        boxShadow: (theme) => theme.customShadows.z8,
      }}
    >
      <Stack
        direction="row"
        spacing={2}
        sx={{
          width: '100%',
          marginTop: '16px',
          marginBottom: '8px',
        }}
      >
        <Box
          sx={{
            width: '20px',
            height: '20px',
            ml: 2,
            color: (theme) => theme.palette.orange[0],
            pt: 0.5,
          }}
        >
          <Iconify
            width={20}
            height={20}
            icon={'material-symbols:star-outline'}
          />
        </Box>
        <Box>
          <Typography
            variant="body2"
            component="div"
            sx={{
              fontWeight: 600,
            }}
          >
            {t('checkout.home.fan.title')}
          </Typography>
          <Typography
            variant="body2"
            component="div"
            sx={{
              fontWeight: 400,
            }}
          >
            {t('checkout.home.fan.label')}
          </Typography>
        </Box>
      </Stack>
      <Divider />
      <Box
        sx={{
          width: '100%',
          p: 2,
        }}
      >
        <TextField
          fullWidth
          size={isMobile ? 'small' : 'medium'}
          onChange={onChangeHandler}
          value={value}
          error={error}
          helperText={error}
        />
      </Box>
      <Box
        sx={{
          width: '100%',
          pl: 2,
          pr: 2,
          pb: 2,
        }}
      >
        <Button
          type="submit"
          variant="contained"
          fullWidth
          onClick={onContinue}
        >
          {t('checkout.buttons.continue')}
        </Button>
      </Box>
    </Box>
  );
}
